import React, {useContext, useRef} from "react";
import useAxios from "axios-hooks";

import { Patient, MeasurementAPIResponse } from "../../../../Types";
import { MeasurementCard } from "./MeasurementCard";
import { AuthContext } from "../../../../Contexts";

import {
  CoverTestConfig,
  NearPointConvergenceConfig,
  VonGraefeConfig,
  VergenceFacilityConfig,
  IntraocularPressureConfig, NotesConfig,
} from "./MeasurementTypes";
import { Interface } from "readline";
import {LoadingIcon} from "../../../../Components/Icons/LoadingIcon";
import {Button, Card} from "rebass";
import {CardHeader} from "../../../../Components";
import {OtherVisualFieldResultsConfig} from "./MeasurementTypes/OtherVisualFieldResults";

export const MeasurementContainer: React.FC<{
  patient: Patient;
}> = ({ patient }) => {
  const authContext = useContext(AuthContext);

  // const [measurements, setMeasurements] = useState<Measurement[]>([]);

  const [{ data, loading, error }, execute] = useAxios<MeasurementAPIResponse>({
    url: "/vue_api/get_measurements",
    data: {
      p: authContext.user?.pass_hash,
      u: authContext.user?.user_name,
      clinic_user_id: patient?.clinic_user_id,
    },
    method: "post",
  });

  const onMeasurementAdd = () => {
    execute();
  };

  if (loading) {
    return <LoadingIcon/>;
  }

  if (error) {
    return <div>Something went wrong :(</div>;
  }

  const measurements =
    data && data.measurements
      ? data.measurements.filter((m) => m.is_valid === "1")
      : [];

  return (
    <div>
      <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...IntraocularPressureConfig}
      />
      {/* <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...CoverTestConfig}
      /> */}
      <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...NotesConfig}
      />
      {/* <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...OtherVisualFieldResultsConfig}
      /> */}
      {/*
    <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        measurements={measurements}
        {...NearPointConvergenceConfig}
        patient={patient}
    />
      <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...VonGraefeConfig}
      />
      <MeasurementCard
        onMeasurementAdd={onMeasurementAdd}
        patient={patient}
        measurements={measurements}
        {...VergenceFacilityConfig}/>
      */}
    </div>
  );
};
